import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleRedirect } from "../authConfig";

export default function Callback({ onLogin }) {
  const navigate = useNavigate();

  useEffect(() => {
    async function processRedirect() {
      try {
        console.log(
          "Callback: Processing redirect, hash:",
          window.location.hash
        );
        const result = await handleRedirect();
        if (result && result.user) {
          console.log("Callback: Backend login successful, user:", result.user);
          console.log("Callback: Tenant ID:", result.tenantId);
          onLogin(result.user);

          const savedRoute = localStorage.getItem("lastVisitedRoute");
          console.log("Callback: Checking saved route:", savedRoute);

          const validRoutes = [
            "/Projects",
            "/Projects/:id",
            "/Leads",
            "/Leads/:id",
            "/Opportunities",
            "/Opportunities/:opportunityId",
            "/contacts",
            "/accounts",
            "/timesheets",
            "/pieceworkerlog",
            "/finances",
            "/bills",
            "/labour-items",
            "/users",
            "/payroll",
          ];

          if (savedRoute) {
            const { pathname, state } = JSON.parse(savedRoute);
            const isValidRoute = validRoutes.some((route) =>
              route.includes(":id")
                ? pathname.match(route.replace(":id", "[^/]+"))
                : route === pathname
            );

            if (
              isValidRoute &&
              pathname !== "/login" &&
              pathname !== "/callback" &&
              pathname !== "/"
            ) {
              console.log("Callback: Restoring saved route:", {
                pathname,
                state,
              });
              navigate(pathname, { state, replace: true });
            } else {
              console.log(
                "Callback: Invalid saved route, navigating to /Projects"
              );
              navigate("/Projects", { replace: true });
            }
          } else {
            console.log("Callback: No saved route, navigating to /Projects");
            navigate("/Projects", { replace: true });
          }
        } else {
          console.error("Callback: No user data from backend");
          navigate("/login");
        }
      } catch (error) {
        console.error("Callback error:", error);
        navigate("/login");
      }
    }
    processRedirect();
  }, [navigate, onLogin]);

  return <div>Loading...</div>;
}
